import { render, staticRenderFns } from "./listComponent.vue?vue&type=template&id=6d204e42&scoped=true"
import script from "./listComponent.vue?vue&type=script&lang=js"
export * from "./listComponent.vue?vue&type=script&lang=js"
import style0 from "./listComponent.vue?vue&type=style&index=0&id=6d204e42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d204e42",
  null
  
)

export default component.exports